import '../app.css'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import cs from 'vuetify/src/locale/cs'
import Vuetify from 'vuetify'
import { errorHandlerMixin } from './errorHandlerMixin.js'
import 'vanilla-cookieconsent/dist/cookieconsent.js'
import VFormNewsletter from '../vue/components/VFormNewsletter.vue'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  lang: {
    locales: { cs },
    current: 'cs'
  },
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: { disable: true }
})

export default {
  el: '#app',
  vuetify,
  components: {
    VFormNewsletter
  },
  mixins: [
    errorHandlerMixin
  ],
  data () {
    return {
      menu: false,
      filter: false
    }
  },
  methods: {
    toggleMenu () {
      this.menu = !this.menu
    },
    openCookieSettings () {
      cc.showSettings()
    }
  }
}

// obtain plugin
const cc = initCookieConsent()

// run plugin with your configuration
cc.run({
  current_lang: 'cs',
  // Activates <script type="text/plain" data-cookiecategory="..."> tags after consent
  page_scripts: true,
  onFirstAction: function (user_preferences, cookie) {
    // callback triggered only once
  },
  onAccept: function (cookie) {
    // ...
  },
  onChange: function (cookie, changedPreferences) {
    // gtag.js already running on this page would write its cookies again after autoclear
    if (changedPreferences.includes('analytics') && !cc.allowedCategory('analytics')) {
      window['ga-disable-G-YL99HLZ9XK'] = true
    }
  },
  languages: {
    cs: {
      consent_modal: {
        title: 'Souhlas s používáním cookies',
        description: 'Používáme nezbytné cookies, bez kterých web nefunguje, a s Vaším souhlasem také analytické cookies Google Analytics, které nám pomáhají web zlepšovat. <button type="button" data-cc="c-settings" class="cc-link">Nastavit podrobně.</button>',
        primary_btn: {
          text: 'Přijmout všechny',
          role: 'accept_all'
        },
        secondary_btn: {
          text: 'Přijmout povinné',
          role: 'accept_necessary'
        }
      },
      settings_modal: {
        title: 'Nastavení cookies',
        save_settings_btn: 'Uložit nastavení',
        accept_all_btn: 'Přijmout všechny',
        reject_all_btn: 'Odmítnout všechny',
        close_btn_label: 'Zavřít',
        cookie_table_headers: [
          { col1: 'Název' },
          { col2: 'Doména' },
          { col3: 'Expirace' },
          { col4: 'Popis' }
        ],
        blocks: [
          {
            title: 'Souhlas s používáním cookies',
            description: 'Zde máte možnost přizpůsobit soubory cookie podle kategorií, v souladu s vlastními preferencemi.'
          }, {
            title: 'Technické cookies',
            description: 'Jsou nezbytné k tomu, aby web fungoval, takže není možné je vypnout. Většinou jsou nastavené jako odezva na akce, které jste provedli, jako je požadavek služeb týkajících se nastavení soukromí, přihlašování, vyplňování formulářů atp. Prohlížeč můžete nastavit tak, aby blokoval soubory cookie nebo o nich posílal upozornění. Mějte na paměti, že některé stránky bez těchto souborů nebudou fungovat. Tyto soubory cookie neukládají žádné osobní identifikovatelné informace.',
            toggle: {
              value: 'necessary',
              enabled: true,
              readonly: true
            }
          }, {
            title: 'Analytické cookies',
            description: 'Analytické cookies nás informují o tom, jak zákazníci využívají tuto webovou stránku v průběhu návštěvy. Pomocí těchto cookies sbíráme statistické informace, nikoli Vaše osobní. Pomáhají nám vylepšit dynamiku a přehlednost webu.',
            toggle: {
              value: 'analytics',
              enabled: false,
              readonly: false
            },
            cookie_table: [
              {
                col1: '^_ga',
                col2: 'ekcr.info',
                col3: '2 roky',
                col4: 'Slouží k hodnocení chování zákazníků na našich webových stránkách. Uživatel je hodnocen pouze na základě cookies. Žádné další údaje použity nejsou, a díky tomu je zajištěna uživatelova anonymita. ',
                is_regex: true,
                domain: 'ekcr.info'
              }
            ]
          }, {
            title: 'Více informací',
            description: 'Pro dotazy ohledně zpracování osobních údajů kontaktujte <a class="cc-link" href="mailto:podpora@ekcr.cz">technickou podporu</a>.'
          }
        ]
      }
    }
  }
})
